export default "/images/2531939ff37e09517784ded71385f545.avif";